import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import BlogSection from 'components/common/sections/BlogSection';
import TryDemoSection from 'components/common/sections/TryDemoSection';
import BlogHeaderLarge from 'assets/images/blog-header-large.png';


const BlogDetail = () => (
  <>
    {/* Blog header section */}
    <section id="blog-header-section" className="mb-2">
      <Container className="mt-5">
        <Row>
          <Col sm={12}>
            <h2>A personal letter from our CEO</h2>
            <p>
              Nik Storonsky
              <span style={{color: "#00000099", marginLeft: "20px"}}>03/01/2022</span>
              <i className="bi bi-twitter" style={{color: "#301E67", marginLeft: "20px"}}></i>
              <i className="bi bi-facebook" style={{color: "#301E67", marginLeft: "20px"}}></i>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Image Section */}
    <section id="blog-image-section" className="mb-3 mt-5 mt-lg-0">
      <Container fluid className="mt-2 px-0">
        <Row>
          <Col sm={12} className="text-center px-0 mb-2 mb-lg-4">
            <img className="img-fluid" src={BlogHeaderLarge} alt=""/>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Content section */}
    <section id="blog-content-section">
      <Container className="mt-3">
        <Row className="d-flex justify-content-center">
          <Col sm={12} lg={10} xl={8}
               className="d-flex align-items-center text-left mt-3 mt-lg-0 ps-2 ps-lg-5 bg-white">
            <div>
              <p style={{color: "#000000cc"}}>
                Dear Investors,
                <br/><br/>
                I am thrilled to share with you the latest news and developments from our investment platform.
                Over the past few months, we have been working tirelessly to improve our services and offerings
                to ensure that we continue to provide you with the best investment opportunities.
                <br/><br/>
                Firstly, I would like to highlight the expansion of our investment portfolio. We have added several
                new assets, including cryptocurrencies, commodities, and international stocks. Our team has conducted
                thorough research to identify these opportunities, and we are confident that they will offer excellent
                returns to our investors.
                <br/><br/>
                We have also made significant improvements to our platform's user interface, making it easier
                for you to navigate and manage your investments. Our team has implemented state-of-the-art
                security measures to ensure that your personal and financial information is always safe and secure.
                <br/><br/>
                One of our top priorities has always been to provide our investors with a personalized investment
                experience. In line with this, we have introduced a new investment option that allows you to create
                your investment portfolio based on your unique preferences and risk tolerance. Our team of financial
                experts will work with you to develop a customized investment plan that meets your goals and objectives.
              </p>
              <div style={{
                borderLeft: "groove",
                padding: "20px 0 20px 20px",
                marginBottom: "20px",
                borderColor: "#511281"
              }}>
                <h4 style={{
                  paddingTop: "10px",
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "32px",
                  letterSpacing: "0px"
                }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper mattis lorem non.
                  Ultrices praesent amet ipsum justo massa. Eu dolor aliquet risus gravida nunc at feugiat consequat
                  purus.
                </h4>
                <p className="larger-p" style={{marginTop: "40px", color: "#000000cc"}}>— John Doe, CEO & Founder</p>
              </div>
              <p style={{color: "#000000cc"}}>
                We understand that transparency is crucial when it comes to investing. That's why we have also
                introduced
                new tools that allow you to track the performance of your investments in real-time. You can now access
                comprehensive reports on your portfolio's performance, including detailed breakdowns of your
                investments'
                returns and fees.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog section 2 */}
    <BlogSection/>

    {/* Try CTA section */}
    <TryDemoSection/>
  </>
);

export default BlogDetail;